module.exports = __webpack_public_path__ + "img/moneynote.689b3df7.png";